/** 임금대장·사원 매칭용 성명+생년월일 키 */

export function normalizeEmpName(name?: string | null): string {
  return String(name ?? '').trim();
}

export function normalizeEmpBirth(birth?: string | null): string | null {
  if (birth == null || birth === '') return null;
  const s = String(birth).trim().substring(0, 10);
  return s || null;
}

export function buildEmpMatchKey(name?: string | null, birth?: string | null): string {
  return `${normalizeEmpName(name)}|${normalizeEmpBirth(birth) ?? ''}`;
}

/** 임금 저장 시 인사관리(ce_birth_date) 생년월일 우선 */
export function resolveAuthoritativeBirth(row: {
  birth?: string | null;
  ce_birth_date?: string | null;
  cwhd_birth?: string | null;
}): string | null {
  return (
    normalizeEmpBirth(row.ce_birth_date)
    ?? normalizeEmpBirth(row.cwhd_birth)
    ?? normalizeEmpBirth(row.birth)
  );
}

/** 급여대장 API(camelCase name/birth) · DB(cwhd_*) · 사원(ce_*) 공통 */
export function resolveWageRowName(row: {
  name?: string | null;
  cwhd_name?: string | null;
  ce_name?: string | null;
}): string {
  return normalizeEmpName(row.cwhd_name || row.ce_name || row.name);
}

/** 임금 목록 행의 식별 키 (성명+생년월일) */
export function rowEmpKey(row: {
  emp_match_key?: string;
  name?: string | null;
  birth?: string | null;
  cwhd_name?: string | null;
  ce_name?: string | null;
  cwhd_birth?: string | null;
  ce_birth_date?: string | null;
}): string {
  return (
    row.emp_match_key
    || buildEmpMatchKey(resolveWageRowName(row), resolveAuthoritativeBirth(row))
  );
}
